export type TestVariant = 'A' | 'B' | 'C';

export function getTestVariant(
  mandatoryAccount: boolean,
  mandatoryAccountVariant: boolean,
): TestVariant {
  return !mandatoryAccount ? 'A' : mandatoryAccountVariant ? 'B' : 'C';
}
